import React, { useEffect, useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import Form from 'react-bootstrap/Form';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from 'primereact/inputswitch';
import { useDropzone } from 'react-dropzone';
import { Dropdown } from 'primereact/dropdown';
// import './products.css'
import { RadioButton } from "primereact/radiobutton";
import { Skeleton } from 'primereact/skeleton';

//icons
import Edit from '../../../assets/icons/edit.svg';
import Trash from '../../../assets/icons/trash.svg';
import WhiteTrash from '../../../assets/icons/white-trash.svg'
import Upload from '../../../assets/icons/upload.svg'
import { AttachFileCreate, AttachFileDelete, AttachFileUpdate, baseUrl, bearer, CreateContact, DeleteContact, GetContact, SearchContact, UpdateContact } from '../../../utils/api';
import { Button, InputGroup } from 'react-bootstrap';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import useToastNotification from '../../../hooks/useToastNotification';
import Loader from '../../loader/loader'


function Banner() {
    const [addFormValidated, setAddFormValidated] = useState(false);
    const [editFormValidated, setEditFormValidated] = useState(false);
    const { showError, showSuccess } = useToastNotification();
    const [visible, setVisible] = useState(false);
    const [editvisible, setEditVisible] = useState(false);
    const [status, setStatus] = useState(false);
    const [showInLandingPage, setShowInLandingPage] = useState(false);
    const [title, setTitle] = useState('');
    const [value, setValue] = useState('');
    const [uploadedFile, setUploadedFile] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [customers, setCustomers] = useState([]);
    const [imagePreview, setImagePreview] = useState([]);
    const [uploadStatus, setUploadStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [defaultImg, setDefaultImg] = useState('');
    const initialSelectedItemProperties = {
        "title": "",
        "value": true,
        "images": [],
    };
    const [selectedItem, setSelectedItem] = useState({ ...initialSelectedItemProperties });

    const loadContacts = async (page = pageIndex, size = pageSize) => {
        try {
            let response = await SearchContact({
                pageIndex: page,
                pageSize: size,
            });
            console.log(response.data.data.total)
            setItems(response.data.data.items);
            setTotalRecords(response.data.data.total);
        } catch (error) { }
    };


    useEffect(() => {
        loadContacts();
        console.log('....')

    }, [pageIndex, pageSize]);

    useEffect(() => {
        loadContacts();
        console.log('....')

    }, []);
    const onStatusChange = async (rowData, value) => {

        const convertToBase64 = async (file) => {
            return await toBase64(file).then(result =>
                result.substr(result.indexOf(",") + 1)
            );
        };
        // Initialize fileBase64
        let fileBase64 = '';

        if (rowData.logoPath) {
            // Fetch the file from the logoPath and convert to Base64
            try {
                const response = await fetch(baseUrl + 'IO/' + rowData.logoPath); // Assuming `logoPath` is a URL
                const blob = await response.blob();
                fileBase64 = await convertToBase64(blob);
            } catch (error) {
                console.error("Error converting logoPath to Base64:", error);
                showError("مشکلی در تبدیل لوگو به Base64 وجود دارد.");
                setLoading(false);
                return;
            }
        }
        const updatedItem = {
            ...rowData,
            logoPath: null, // Remove logoPath from the object
            fileBase64, isActive: value
        };
        await UpdateContact(updatedItem).then(() => {
            const updatedItems = items.map(item =>
                item.id === rowData.id ? { ...item, isActive: value } : item
            );
            setItems(updatedItems);
            showSuccess("عملیات با موفقیت انجام شد");
        }).catch(error => showError(error));
    };

    const statusSwitchTemplate = (rowData) => {
        return (
            <InputSwitch
                checked={rowData.isActive}
                onChange={(e) => onStatusChange(rowData, e.value)}
            />
        );
    };
    const openEditDialog = (rowData) => {
        console.log(rowData)
        setUploadStatus("");
        setSelectedItem(rowData);
        setEditVisible(true);
        document.body.style.overflow = 'hidden';
    };
    const actionTemplate = (rowData) => {
        return (
            <div className='d-flex justify-content-center gap-2' style={{ borderRight: '0.5px solid #D2D2D2' }}>
                <img
                    src={Edit}
                    alt="edit"
                    className="cursor-pointer mx-1"
                    onClick={() => openEditDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
                <img
                    src={Trash}
                    alt="delete"
                    className="cursor-pointer mx-1"
                    onClick={() => openDeleteDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
            </div>
        );
    };

    const handleEdit = (rowData) => {
        console.log('Editing:', rowData);
        setEditVisible(true);
        document.body.style.overflow = 'hidden';
    };

    const deleteItem = async (item) => {
        await DeleteContact({ id: item.id }).then(() => {
            showSuccess("عملیات با موفقیت انجام شد");
            setItems(old => old.filter(filter => item.id !== filter.id));
        }).catch(error => {
            showError(error.response.data.message);
        });
    };
    const openDeleteDialog = async (rowData) => {
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

        confirmDialog({
            message: 'آیا از حذف آیتم اطمینان دارید؟',
            header: 'حذف آیتم',
            defaultFocus: 'reject',
            maskClassName: 'flex',
            headerClassName: '!pr-1 !pl-1',
            acceptClassName: 'btn btn-danger mx-1',
            rejectClassName: 'btn btn-secondary mx-1',
            acceptLabel: 'حذف',
            rejectLabel: 'انصراف',
            resizable: false,
            accept: () => {
                deleteItem(rowData)
                document.body.style.overflow = 'auto';
            },
            reject: () => {
                document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول
            },
        });
    };








    const openAddDialog = () => {
        setLoading(false);
        setUploadStatus("");
        setVisible(true);
        document.body.style.overflow = 'hidden';

    };
    const closeAddDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        setUploadStatus("");
        setVisible(false);
        setAddFormValidated(false)
        document.body.style.overflow = 'auto';
        // reset properties to default
        setImagePreview([]);
        setUploadedFile([]);
        setTitle("");
        setValue("");
        setStatus(true);
    };





    // Upload handler for add
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {
            if (selectedItem?.images?.length >= 1) {
                showError('حداکثر تعداد عکس ها 1 عدد است');
                return;
            }
            if (imagePreview.length >= 1) {
                showError('حداکثر تعداد عکس ها 1 عدد است');
                return;
            }

            // Append new files
            const newFiles = acceptedFiles.slice(0, 1 - uploadedFile.length); // Limit to the remaining count
            const updatedFiles = [...uploadedFile, ...newFiles];
            setUploadedFile(updatedFiles);

            // Clear previews and set new previews
            const newPreviews = newFiles.map(file => URL.createObjectURL(file));
            let newPreviewsValue = [...imagePreview, ...newPreviews];
            setImagePreview(newPreviewsValue);
            setDefaultImg(newPreviewsValue.length - 1);

            // Automatically upload the file
            // newFiles.forEach(file => handleFileUpload(file));
        },

        accept: 'image/*',
        maxFiles: 4 // Limit to a maximum of 4 files

        // Automatically upload the file
    });



    const handleFileUploadAdd = async (file, id, isDefault) => {
        let base64 = await toBase64(file);
        base64 = base64.substr(base64.indexOf(',') + 1, base64.length);

        return base64

    };


    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (uploadedFile.length == 0) {
            showError("لطفا عکس را وارد کنید.");
            return
        }
        if (form.checkValidity() === true) {
            try {
                setLoading(true);
                const file = uploadedFile[0];
                const base64 = await toBase64(file).then(result =>
                    result.substr(result.indexOf(",") + 1)
                );
                let payload = {
                    title: title,
                    value: value,
                    fileBase64: base64
                };

                let res = await CreateContact(payload)
                if (res.data.isSuccess) {
                    const id = res.data.data; //created item id
                    setLoading(false);
                    closeAddDialog();
                    loadContacts()
                    showSuccess("عملیات با موفقیت انجام شد");
                }


            } catch (error) {
                setLoading(false);
                showError(error.response?.data?.message);
            }
        } else {
            setAddFormValidated(true)
        }

    };
    const onAddItemSubmitted = async (id) => {
        // add images if exist 
        for (let index = 0; index < uploadedFile.length; index++) {
            const image = uploadedFile[index];
            await handleFileUploadAdd(image, id, index === defaultImg);
        }

    }



    // Upload handler for edit
    const { getRootProps: getRootPropsEdit, getInputProps: getInputPropsEdit } = useDropzone({
        onDrop: (acceptedFiles) => {
            if (selectedItem.images.length >= 1) {
                showError('حداکثر تعداد عکس ها 1 عدد است');
                return;
            }

            // Append new files
            const newFiles = acceptedFiles.slice(0, 1 - uploadedFile.length); // Limit to the remaining count
            const updatedFiles = [...uploadedFile, ...newFiles];
            setUploadedFile(updatedFiles);

            // Clear previews and set new previews
            const newPreviews = newFiles.map(file => URL.createObjectURL(file));
            let newPreviewsValue = [...imagePreview, ...newPreviews];
            setImagePreview(newPreviewsValue);
            setDefaultImg(newPreviewsValue.length - 1);

            // Automatically upload the file
            // newFiles.forEach(file => handleFileUpload(file));
        },

        accept: 'image/*',
        maxFiles: 4 // Limit to a maximum of 4 files
    });

    // Function to handle the file upload
    const handleFileUpload = async (file) => {
        let base64 = await toBase64(file);
        base64 = base64.substr(base64.indexOf(',') + 1, base64.length);


        // const formData = new FormData();
        // formData.append('filsBase64', base64);
        // formData.append('sourceId', selectedItem.id);
        // formData.append('isDefault', true);

        let formData = {
            sourceId: selectedItem.id,
            filsBase64: base64,
            isDefault: true,
        };


        showSuccess('در حال آپلود فایل');
        await AttachFileCreate(formData)
            .then(data => {
                updateImagesList(selectedItem.id);
                showSuccess('آپلود فایل با موفقیت انجام شد');
            })
            .catch(error => {
                showError('عملیات آپلود با خطا مواجه شد');
            });
    };
    const handleRemoveImage = (index) => {
        setUploadedFile(prevFiles => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1); // Remove the file at the specified index
            return newFiles;
        });

        setImagePreview(prevPreviews => {
            const newPreviews = [...prevPreviews];
            newPreviews.splice(index, 1); // Remove the preview at the same index
            return newPreviews;
        });
    };

    const updateImagesList = async (id) => {
        await GetContact({ id }).then(response => {
            console.log(response)
            const images = (response.data.data.images);
            setSelectedItem(old => ({ ...old, images }));
        });
    };
    const removeImage = async () => {
        setSelectedItem((prevItem) => ({
            ...prevItem,
            logoPath: null, // حذف مسیر عکس از داده‌های لوکال
        }));
    };
    const changeDefaultImage = async (id) => {
        await AttachFileUpdate({ imageId: id }).then(() => {
            setSelectedItem(old => {
                const clone = { ...old };
                clone.images = clone.images.map(item => {
                    if (item.id === id) {
                        return { ...item, isDefault: true };
                    }
                    else {
                        return { ...item, isDefault: false };
                    }
                })
                return clone;
            })

        }).catch((error) => {
            console.log(error);
        });
    };
    const updateSelectedItem = (key, value) => {
        setSelectedItem(old => {
            let clone = { ...old };
            clone[key] = value;
            return clone;
        })
    };

    const closeEditDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        // setUploadStatus("");

        setEditVisible(false);
        document.body.style.overflow = 'auto';
        setImagePreview([]);
        setUploadedFile([]);
    };

    const submitEdit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (uploadedFile.length == 0 && !selectedItem.logoPath) {
            showError("لطفا عکس را وارد کنید.");
            return
        }
        if (form.checkValidity() === true) {
            setLoading(true);

            // Function to convert to Base64
            const convertToBase64 = async (file) => {
                return await toBase64(file).then(result =>
                    result.substr(result.indexOf(",") + 1)
                );
            };

            // Initialize fileBase64
            let fileBase64 = null;

            if (selectedItem.logoPath) {
                // Fetch the file from the logoPath and convert to Base64
                try {
                    const response = await fetch(baseUrl + 'IO/' + selectedItem.logoPath); // Assuming `logoPath` is a URL
                    const blob = await response.blob();
                    fileBase64 = await convertToBase64(blob);
                } catch (error) {
                    console.error("Error converting logoPath to Base64:", error);
                    showError("مشکلی در تبدیل لوگو به Base64 وجود دارد.");
                    setLoading(false);
                    return;
                }
            } else if (uploadedFile.length > 0) {
                // Convert the uploaded file to Base64
                fileBase64 = await convertToBase64(uploadedFile[0]);
            }

            // Create the updated item to send to the server
            const { logoPath, ...updatedItem } = {
                ...selectedItem,
                fileBase64
            };

            try {
                let response = await UpdateContact(updatedItem); // Send updated item to server
                if (response.status === 200) {
                    setItems(old => {
                        let clone = [...old];
                        clone = clone.map(item => {
                            if (item.id === updatedItem.id) {
                                return updatedItem; // Update the item with the new data
                            }
                            return item;
                        });
                        return clone;
                    });
                    showSuccess("عملیات با موفقیت انجام شد");
                    loadContacts()
                    closeEditDialog();
                }
            } catch (error) {
                showError(error.response.data.message);
            } finally {
                setLoading(false);
            }
        } else {
            setEditFormValidated(true)
        }
    };

    const handlePagination = (event) => {
        // Update the pageIndex and pageSize based on the event
        setPageIndex(event.page + 1);
        setPageSize(event.rows);

        // Trigger a data fetch for the new page
        loadContacts(event.page, event.rows);
    };
    // قالب اسکلتون
    const skeletonBodyTemplate = () => {
        return <Skeleton width="100%" height="1.5rem" />;
    };
    return (
        <>
            <div className='w-100 d-flex justify-content-between bg-white p-2 align-items-center border-solid border'>
                <h6 className='font-bold text-sm mb-0'>درگاه امور مشتریان</h6>
                <button className='btn btn-primary' onClick={openAddDialog}>تعریف  درگاه</button>
            </div>
            <div className=''>
                <DataTable value={items}
                    size="small"
                    paginator
                    rows={pageSize}
                    totalRecords={totalRecords}
                    lazy
                    onPage={handlePagination}
                    first={(pageIndex - 1) * pageSize} // Current first record index
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                    tableStyle={{ minWidth: '50rem' }}>
                    <Column field="id" header="ردیف" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="title" header="نام درگاه" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="value" header="مشخصات" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column header="وضعیت" body={statusSwitchTemplate}></Column>
                    <Column header="عملیات" body={actionTemplate} ></Column>
                </DataTable>
            </div>

            {/* add category  */}
            <Dialog header="تعریف درگاه امور مشتریان" visible={visible} maximizable style={{ width: '40vw' }} onHide={() => {
                if (!visible) return; {
                    setVisible(false);
                    document.body.style.overflow = 'auto';
                }
            }}>
                <div className='dialog-body mx-4'>
                    <Form noValidate validated={addFormValidated} className='mt-3' action='#' onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>نام درگاه</Form.Label>
                            <Form.Control type="text" required value={title} onChange={(e) => setTitle(e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                نام درگاه را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>مشخصات راه ارتباطی</Form.Label>
                            <Form.Control type="text" required value={value} onChange={(e) => setValue(e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                مشخصات راه ارتباطی را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-3" controlId="exampleForm.ControlInput1">
                            <InputSwitch checked={status} onChange={(e) => setStatus(e.value)} />
                            <Form.Label className='font-bold mb-0' style={{ width: 'fit-content', fontWeight: '700 !important' }}>وضعیت</Form.Label>
                        </Form.Group>
                        <div className="upload-box mt-4 mb-0 flex-1" {...getRootProps()} style={{ borderRadius: '8px', minHeight: '112px', minWidth: '112px' }}>
                            <input {...getInputProps()} />
                            <div>
                                <img src={Upload} alt="" className='mx-auto' />

                                <p className='text-xs mt-2 font-medium'>آپلود آیکون مربوط به درگاه امور مشتریان.</p>
                                <h6 className='text-[10px]'>بهترین ابعاد: 16 *16</h6>
                                <h6 className='text-[10px]'>رنگ ایکون سفید باشد.</h6>
                            </div>

                        </div>ّ
                        <div className='d-flex gap-2 align-items-center' style={{ flexWrap: 'wrap' }}>
                            {
                                imagePreview.length > 0 &&
                                <div className="image-preview-container d-flex gap-2" style={{ flexWrap: 'wrap' }}>
                                    {imagePreview.map((image, index) => (
                                        <div className='list-defult'>

                                            <div className='d-flex align-items-center gap-2 mt-4' style={{ flexWrap: 'wrap' }}>
                                                <div className='upload-file-btn'>
                                                    <img src={image} alt="Uploaded preview" className="image-preview" />
                                                    <div className='upload-file-btn-bottom'>
                                                        <div>
                                                            <img src={Trash} alt="" onClick={() => handleRemoveImage(index)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    ))}
                                </div>
                            }


                        </div>


                        {uploadStatus && <p className="upload-status">{uploadStatus}</p>}

                        <button type="submit" disabled={loading} className="btn btn-primary w-100 mt-4">تایید و ثبت {loading && <Loader />}</button>
                    </Form>
                </div>
            </Dialog>



            {/* Edit popup  */}
            <Dialog header="ویرایش درگاه امور مشتریان" visible={editvisible} maximizable style={{ width: '40vw' }} onHide={() => {
                if (!editvisible) return; {
                    setEditVisible(false);
                    document.body.style.overflow = 'auto';
                }
            }}>
                <div className='dialog-body mx-4'>
                    <Form noValidate validated={editFormValidated} className='mt-3' onSubmit={submitEdit} onKeyUp={(e) => (e.key === "Enter") && e.preventDefault()}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>نام درگاه</Form.Label>
                            <Form.Control type="text" required value={selectedItem.title} onChange={(e) => updateSelectedItem('title', e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                نام درگاه را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>مشخصات راه ارتباطی</Form.Label>
                            <Form.Control type="text" required value={selectedItem.value} onChange={(e) => updateSelectedItem('value', e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                مشخصات راه ارتباطی را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-3" controlId="exampleForm.ControlInput1">
                            <InputSwitch checked={selectedItem.isActive} onChange={(e) => updateSelectedItem('isActive', !selectedItem.isActive)} />
                            <Form.Label className='font-bold mb-0' style={{ width: 'fit-content', fontWeight: '700 !important' }}>وضعیت</Form.Label>
                        </Form.Group>
                        <div className="upload-box mt-4 mb-0 flex-1" {...getRootProps()} style={{ borderRadius: '8px', minHeight: '112px', minWidth: '112px' }}>
                            <input {...getInputProps()} />
                            <div>
                                <img src={Upload} alt="" className='mx-auto' />
                                <p className='text-xs mt-2 font-medium'>آپلود آیکون مربوط به درگاه امور مشتریان.</p>
                                <h6 className='text-[10px]'>بهترین ابعاد: 16 *16</h6>
                                <h6 className='text-[10px]'>رنگ ایکون سفید باشد.</h6>
                            </div>

                        </div>
                        <div className="d-flex gap-2 align-items-center" style={{ flexWrap: 'wrap' }}>
                            {selectedItem.logoPath != null ? (
                                <>


                                    <div className="image-preview-container d-flex gap-2" style={{ flexWrap: 'wrap' }}>
                                        <div className="list-defult">
                                            <div className="d-flex align-items-center gap-2 mt-4" style={{ flexWrap: 'wrap' }}>
                                                <div className="upload-file-btn">
                                                    <img src={baseUrl + 'IO/' + selectedItem.logoPath} alt="Uploaded preview" className="image-preview" />
                                                    <div className="upload-file-btn-bottom">

                                                        <div>
                                                            <img src={Trash} alt="حذف" onClick={() => removeImage()} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> </>
                            )

                                : (<>

                                    {
                                        imagePreview.length > 0 &&
                                        <div className="image-preview-container d-flex gap-2" style={{ flexWrap: 'wrap' }}>
                                            {imagePreview.map((image, index) => (
                                                <div className='list-defult'>

                                                    <div className='d-flex align-items-center gap-2 mt-4' style={{ flexWrap: 'wrap' }}>
                                                        <div className='upload-file-btn'>
                                                            <img src={image} alt="Uploaded preview" className="image-preview" />
                                                            <div className='upload-file-btn-bottom'>

                                                                <div>
                                                                    <img src={Trash} alt="" onClick={() => handleRemoveImage(index)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            ))}
                                        </div>


                                    }
                                </>)

                            }


                        </div>
                        {uploadStatus && <p className="upload-status">{uploadStatus}</p>}
                        <div className='d-flex align-items-center gap-2 mt-4'>
                            <button type="submit" disabled={loading} className="btn btn-primary flex-1">  تایید و ثبت{loading === true && <Loader />}</button>
                            <button type="button" disabled={loading} className="btn btn-outline-primary flex-1" onClick={closeEditDialog}>انصراف</button>
                        </div>
                    </Form>

                </div>
            </Dialog>
        </>
    );
}

export default Banner;
